import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export type NavigationConfirmDialogProps = {
  open: boolean;
  title?: string;
  content?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function NavigationConfirmDialog({
  open,
  title,
  content,
  onConfirm,
  onCancel,
}: NavigationConfirmDialogProps) {
  const { t } = useTranslate();

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: { p: 0 },
      }}
    >
      <DialogTitle sx={{ pb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Iconify icon="solar:danger-triangle-bold" color="warning.main" width={24} />
        {title || t('Unsaved Changes')}
      </DialogTitle>

      <DialogContent sx={{ typography: 'body2', color: 'text.secondary' }}>
        {content || t('You have unsaved changes. Are you sure you want to leave this page?')}
      </DialogContent>

      <DialogActions sx={{ gap: 1 }}>
        <Button variant="outlined" color="inherit" onClick={onCancel}>
          {t('Cancel')}
        </Button>
        <Button variant="contained" color="warning" onClick={onConfirm}>
          {t('Leave Page')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
